import { useState, useEffect } from 'react';
import { getCountyAndTownForAddr } from '../comm';

export const usePlacesAutocomplete = () => {
  const [predictions, setPredictions] = useState([]);
  const autocompleteService = new window.google.maps.places.AutocompleteService();
  const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
  useEffect(() => {
  }, []);

  // 搜尋自動補全的結果
  const searchPredictions = (keyword) => {
    if (keyword.length >= 2) {
      const options = {
        input: keyword,
        componentRestrictions: { country: 'tw' } // 限制範圍在台灣
      };

      autocompleteService.getQueryPredictions(options, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setPredictions(results);
        } else {
          setPredictions([]);
        }
      });
    } else {
      setPredictions([]);
    }
  };


  // 根據 placeId 獲取詳細資料
  const getPlaceDetails = (placeId, callback) => {
    if (!placesService) return;
    placesService.getDetails({ placeId }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        callback(place);
      }
    });
  };
  const searchNearby = async (center, radius, type, maxResults, handleResults) => {
    const url = `https://places.googleapis.com/v1/places:searchNearby`;
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const requestBody = {
      includedTypes: type, // 可修改為需要的類型
      maxResultCount: maxResults,
      locationRestriction: {
        circle: {
          center: center, // 台北101
          radius: radius, // 半徑 1000 公尺
        },
      },
    };
    console.log("requestBody", requestBody)
    try {
      const response = await fetch(`${url}?key=${apiKey}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-FieldMask": "places.id,places.displayName,places.addressComponents,places.location,places.types,places.photos",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log("Nearby Places:", data);
      if (data.places) {
        const fetchPhotoUrl = async (photoName) => {
          const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
          const url = `https://places.googleapis.com/v1/${photoName}/media?key=${apiKey}&maxWidthPx=800`;

          try {
            const response = await fetch(url, { method: "GET", redirect: "follow" });
            return response.url; // 這就是圖片的真正 URL
          } catch (error) {
            console.error("Failed to fetch photo URL:", error);
            return null; // 發生錯誤時回傳 null，避免影響後續處理
          }
        };

        const fetchPlacesWithPhotos = async (data) => {
          const placesWithPhotos = await Promise.all(
            data.places.map(async (place) => {
              
              const photoUrls = place.photos?await Promise.all(
                place.photos.map((photo) => fetchPhotoUrl(photo.name)) // 取得所有照片 URL
              ):[];
              const newAddr=getCountyAndTownForAddr(place.addressComponents);
              return {
                ...place,  // 保留原始的 place 資訊
                photoUrls: photoUrls.filter((url) => url !== null), // 過濾掉失敗的請求
                newAddr:newAddr,
              };
            })
          );

          return placesWithPhotos;
        };

        // 使用範例
        fetchPlacesWithPhotos(data).then((result) => {
          console.log("Places with Photos:", result);
          handleResults(result);
        });
      }
      else
        handleResults([]);
    } catch (error) {
      console.error("Error fetching nearby places:", error);
    }
  };

  /* const searchNearby = (center, radius, type, keyword,maxResults, callback) => {
    fetchNearbyPlaces();
    const request = {
      keyword:keyword,
      location: center,  // 你可以動態使用 map.getCenter()
      radius: radius,    // 搜尋半徑大小
      type: type        // 地點類型，例如 'restaurant', 'park', 'store'
    };
    console.log("request",request)
    let totalResults = []; // 儲存所有獲取的結果
  
    const handleResults = (results, pagination) => {
      // 處理每個結果，並直接生成照片的 URL
      const placesWithPhotos = results.map(place => {
        const photoUrls = place.photos ? 
          place.photos.map(photo => photo.getUrl({ maxWidth: 400 })) : 
          [];
  
        return {
          ...place,  // 保留原始的 place 資訊
          photoUrls  // 新增照片的 URL 陣列
        };
      });
  
      // 將當前的結果加入總結果
      totalResults = [...totalResults, ...placesWithPhotos];
  
      // 如果總結果達到最大數量或超過，就結束並 callback
      if (totalResults.length >= maxResults) {
        callback(totalResults.slice(0, maxResults)); // 返回不超過 maxResults 的資料
        return;
      }
  
      // 如果有下一頁，且尚未達到 maxResults，則繼續搜索
      if (pagination && pagination.hasNextPage) {
        setTimeout(() => {
          pagination.nextPage();  // Google 建議延遲至少 2 秒再請求下一頁
        }, 2000);
      } else {
        // 如果沒有下一頁，直接返回現有的結果
        callback(totalResults);
      }
    };
  
    // 初次搜尋
    console.log("placesService",placesService)
    placesService.nearbySearch(request, (results, status, pagination) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        handleResults(results, pagination);
      } else {
        console.error('Nearby Search failed:', status);
      }
    });
  }; */



  return {
    predictions,
    searchPredictions,
    getPlaceDetails,
    searchNearby,
  };
};
